import React from 'react';

/**
 * Pantalla pública de servicio suspendido.
 *
 * Cara al cliente final: neutra y sin ninguna referencia a pago, deuda,
 * morosidad, facturación o incumplimiento. El motivo real solo se ve en el
 * panel administrativo y en el panel de plataforma.
 *
 * No es un overlay: cuando se muestra, el árbol público del restaurante
 * (menú, productos, precios, carrito, checkout) no se renderiza.
 */
export function PublicSuspendedScreen() {
  return <main className="min-h-screen w-full bg-[#FBF7F2] flex items-center justify-center p-6" data-id="element-2501" data-mp="1gvghyapula3q">
      <div className="w-full max-w-md text-center" data-id="element-2502" data-mp="1ctlkxiey9ivr">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-2503" data-mp="1qrtle0b732bo">
          TEMPORALMENTE SUSPENDIDO
        </h1>

        <p className="text-base text-gray-600 leading-relaxed mb-2" data-id="element-2504" data-mp="1lr5jukpcb337">
          Este establecimiento se encuentra temporalmente fuera de servicio.
        </p>
        <p className="text-base text-gray-600 leading-relaxed" data-id="element-2505" data-mp="2x8f2j50n9r3g">
          Por favor, intentá nuevamente más adelante.
        </p>

        <div className="mt-12 pt-6 border-t border-gray-200" data-id="element-2506" data-mp="2dtc6dqro1wmn">
          <p className="text-xs font-semibold tracking-[0.2em] text-gray-400" data-id="element-2507" data-mp="2isfan8ztnytk">
            NOIZA
          </p>
        </div>
      </div>
    </main>;
}